import React from "react";
import './contact.css';
import {FiMail} from 'react-icons/fi';
import {FaLinkedin} from 'react-icons/fa';
import { profile } from "../../data/profile";

// The EmailJS contact form was removed pending a fix for its env config; see git history to restore it.

const Contact = () => {
    return(
        <section id="contact">
            <div className="container contact__container reveal">
                <span className="section__eyebrow">Contact</span>
                <h2 className="section__title">Let's talk</h2>
                <p className="contact__text text-muted">
                    Open to conversations about data platforms, engineering leadership and applied AI.
                    The fastest way to reach me is email or LinkedIn.
                </p>
                <div className="contact__actions">
                    <a href={`mailto:${profile.email}`} className="btn btn-primary"><FiMail/> {profile.email}</a>
                    <a href={profile.linkedin} target="_blank" rel="noreferrer" className="btn"><FaLinkedin/> LinkedIn</a>
                </div>
            </div>
        </section>
    )
}

export default Contact
